import { render, staticRenderFns } from "./OperaWorkorderDetailDcaWindow.vue?vue&type=template&id=19c2a1d9&scoped=true&"
import script from "./OperaWorkorderDetailDcaWindow.vue?vue&type=script&lang=js&"
export * from "./OperaWorkorderDetailDcaWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaWorkorderDetailDcaWindow.vue?vue&type=style&index=0&id=19c2a1d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c2a1d9",
  null
  
)

export default component.exports